import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'extractText',
})
export class ExtractTextPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = value;
    return this.getTextContent(tempDiv);
  }

  private getTextContent(element: HTMLElement): string {
    let text = '';
    element.childNodes.forEach(node => {
      if (node.nodeType === Node.TEXT_NODE) {
        text += node.textContent;
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        text += this.getTextContent(node as HTMLElement);
      }
    });
    return text.trim();
  }
}
